import classNames from "classnames";

const Chip: React.FC<{
  content: string;
  className?: string;
}> = ({ content, className = "" }) => {
  const classes = classNames(
    className,
    "bg-gray-200 rounded-2xl px-1.5 text-xs font-semibold flex items-center justify-center"
  );
  return <div className={classes}>{content}</div>;
};

export default Chip;
